import baseAPI from "@/http";

const router = "api/seloDiagnosticoEvidencias";

export const seloDiagnosticoEvidenciasAPI = {
  add: (arquivos) =>
    baseAPI.post(`${router}/adicionar-selo-diagnostico-evidencia`, arquivos),
  atualizar: (resposta) =>
    baseAPI.put(`${router}/atualizar-diagnostico-resposta`, resposta),
  delete: (evidenciaId, uf) =>
    baseAPI.delete(`${router}/${evidenciaId}?uf=${uf}`),
  deleteEvidencia: (evidenciaId, uf, parceiro) =>
    baseAPI.delete(
      `${router}/deletar-evidencia?id=${evidenciaId}&uf=${uf}&parceiro=${parceiro}`
    ),
  download: (evidenciaId, uf, parceiro) =>
    baseAPI.get(
      `${router}/download-diagnostico-evidencia/${evidenciaId}?uf=${uf}&parceiro=${parceiro}`,
      { responseType: "blob" }
    ),
  getEvidenciaPerguntas53_54_55_56: (municipioId) =>
    baseAPI.get(
      `${router}/obter-diagnostico-evidencias-by-municipio/${municipioId}`
    ),
};
